import { KeyboardArrowDown } from '@mui/icons-material';
import { Divider, InputLabel, MenuItem, Select, Typography, alpha, inputLabelClasses, styled } from '@mui/material';
import { RookeryRegularFont } from 'v3/styles/common';
import { theme } from 'v3/styles/global-styles';

export const MenuItemDivider = styled(Divider)(() => ({
  backgroundColor: theme.palette.secondary.light,
  height: 0.3,
}));

export const DefaultLabel = styled(Typography)(() => ({
  color: theme.palette.secondary.dark,
  font: RookeryRegularFont,
}));

export const StyledArrowDropDownIcon = styled(KeyboardArrowDown)(() => ({
  color: theme.palette.common.white,
  cursor: 'pointer',
}));

export const selectMenuPaperPropsStyle = {
  style: {
    backgroundColor: theme.palette.primary.dark,
    border: `.1rem solid ${theme.palette.common.white}`,
    borderRadius: '0.5rem',
    padding: '0.5rem, 1.5rem, 0.5rem, 1.5rem',
    maxHeight: '30rem',
  },
};

export const StyledSelect = styled(Select)(({ theme, fullWidth }) => ({
  width: fullWidth ? '100%' : '13rem',
  height: '3rem',
  borderBottom: `.1rem solid ${theme.palette.secondary.light}`,
  color: theme.palette.common.white,
  borderRadius: '0',
  flexGrow: 1,
  font: RookeryRegularFont,
  '& fieldset': {
    border: 'none',
  },
  '&:hover': {
    borderBottom: `.1rem solid ${theme.palette.secondary.light}`,
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.light, 0.6),
  },
  '& .MuiSelect-select ': {
    paddingLeft: 0,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  height: '3rem',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.dark,
  font: RookeryRegularFont,
  flexGrow: 1,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.light, 0.6),
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.dark, 0.6),
  },
}));

export const InputLabelStyled = styled(InputLabel)(({ theme }) => ({
  color: alpha(theme.palette.common.white, 0.6),

  [`&.${inputLabelClasses.focused}`]: {
    color: alpha(theme.palette.common.white, 0.6),
  },
}));
